import Vue from 'vue';
import Router from 'vue-router';
import Login from '../views/Login.vue';
import Menu from '../views/Menu.vue';
import Card from '../components/Card.vue';
import ECharts from '../components/ECharts.vue';
import Table from "../components/Table.vue";
import None from "../components/None.vue";
import Home from "../components/Home.vue";
import Screen from "../components/Screen.vue";
import TestHome from "../components/TestHome.vue";
import TestCard from "../components/TestCard.vue";
import UserHome from "../components/UserHome.vue";
import UserCard from "../components/UserCard.vue";
import UpdatePassword from "../components/UpdatePassword.vue";
import UserNewHome from "../components/UserNewHome.vue";
import AllEquTable from "../components/AllEquTable.vue";
import AllEquEnergy from "../components/AllEquEnergy.vue"
import EnergyThree from "../components/EnergyThree.vue";
import EnergySeven from "../components/EnergySeven.vue";
import EnergyMonth from "../components/EnergyMonth.vue";
import Hlsw from "../components/Hlsw.vue";
import test from '../views/test.vue';
// import CarbonEmission from '../views/CarbonEmission.vue';
import Root from '../views/root.vue';
import User from '../views/user.vue';
import Equipment from '../views/equipment.vue';
import hlsw from '../views/hlsw.vue';
import Hlsw2 from "../components/Hlsw2.vue";
import HLSWLyzYm from "../views/HLSWLyzYm.vue";
Vue.use(Router);

const router = new Router({
  //mode: 'history',
  mode: 'hash',
  routes: [
    {
      path: '/',
      component: Login,
    },
    {
      path: '/menu',
      component: Menu,
      children: [
        { path: 'card', component: Card },
        { path: 'echarts', component: ECharts },
        { path: 'table', component: Table },
        { path: 'none', component: None },
        { path: 'home', component: Home },
        { path: 'userHome', component: UserHome },
        { path: 'userCard', component: UserCard },
        { path: 'testHome', component: TestHome },
        { path: 'testCard', component: TestCard },
        { path: 'updatePassword', component: UpdatePassword },
        { path: 'userNewHome', component: UserNewHome },
        { path: 'allEquTable', component: AllEquTable },
        { path: 'allEquEnergy', component: AllEquEnergy },
        { path: 'EnergyThree', component: EnergyThree },
        { path: 'EnergySeven', component: EnergySeven },
        { path: 'EnergyMonth', component: EnergyMonth },
      ],
      meta: { requiresAuth: true } // 添加一个meta字段，用于标识需要进行登录检查
    },
    { path: '/screen', component: Screen },
    { path: '/hlsws', component: Hlsw },
    { path: '/hlsws2', component: Hlsw2 },
    { path: '/HLSWLyzYm', component: HLSWLyzYm },
    { path: '/test', component: test },
    // { path: '/carbon-emission', component: CarbonEmission },
    { path: '/hlsw', component: hlsw },

    {
      path: '/root',
      component: Root,
      meta: { requiresAuth: true }
    },
    {
      path: '/user',
      component: User,
      meta: { requiresAuth: true }
    },
    {
      path: '/equipment',
      component: Equipment,
      meta: { requiresAuth: true }
    }
  ],
});

// 添加路由守卫
router.beforeEach((to, from, next) => {
  // 检查路由是否需要登录检查
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 判断用户是否已登录
    const loggedIn = localStorage.getItem('user');
    console.log(loggedIn)
    if (!loggedIn) {
      // 如果用户未登录且访问的是需要权限的页面，则重定向到登录页面
      next({
        path: '/',
        query: { redirect: to.fullPath } // 传递当前页面路径作为查询参数，以便登录成功后直接跳转回来
      });
    } else {
      // 如果用户已登录，则继续路由导航
      next();
    }
  } else {
    // 如果路由不需要登录检查，则直接继续路由导航
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js